const SERVICE_ERROR_PAGE_PREFIX = "ServiceErrorPage";

export const SERVICE_ERROR_PAGE_CLASSES = {
  logo: `${SERVICE_ERROR_PAGE_PREFIX}-logo`,
};
